module.exports = __webpack_public_path__ + "img/docs-hover.b429cfd6.svg";